"use strict";

exports.__esModule = true;
exports.default = void 0;
var icons = {
  horizon: {
    width: '1.5',
    lineCap: 'round',
    lineJoin: 'round'
  },
  cannesLions: {
    width: '2.5',
    lineCap: 'square',
    lineJoin: 'arcs'
  },
  money2020: {
    width: '2',
    lineCap: 'butt',
    lineJoin: 'bevel'
  }
};
var _default = icons;
exports.default = _default;